import React, { useState, useEffect, useRef } from "react";
import { useLocation, Link } from "react-router-dom";
import { db } from "../firebase"; 
import { collection, getDocs } from "firebase/firestore"; 
import AdComponent from '../components/AdComponent';

// Données statiques (servent de secours si Firebase est vide)
import { games as initialGames } from "../data/games";
import { reviews } from "../data/reviews";
import { deals } from "../data/deals";

// Composants
import Login from "../components/Login";
import GameCard from "../components/GameCard";
import ReviewCard from "../components/ReviewCard";
import DealCard from "../components/DealCard";

function Home() {
  // ✅ On ne déclare ces variables QU'UNE SEULE FOIS
  const [gamesList, setGamesList] = useState([]); 
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(localStorage.getItem("username"));
  const [currentSlide, setCurrentSlide] = useState(0);

  const location = useLocation();
  const gamesSectionRef = useRef(null);
  const query = new URLSearchParams(location.search);
  const searchTerm = query.get("search");
  
  // ... la suite de ton code (useEffect, etc.) reste identique

  // --- CHARGEMENT DES JEUX DEPUIS FIREBASE ---
  useEffect(() => {
    const fetchGames = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "games"));
        const firebaseGames = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

// On combine les jeux de la base de données ET tes jeux durement travaillés
setGamesList([...firebaseGames, ...initialGames]);
      } catch (error) {
        console.error("Erreur Firebase:", error);
        setGamesList(initialGames); 
      }
      setLoading(false);
    };

    fetchGames();
  }, []);

  const slides = [
    { title: "Bienvenue sur GamePulseHQ", subtitle: "Le futur du gaming commence ici." },
    { title: "Tests & Avis Experts", subtitle: "Ne jouez plus au hasard, lisez nos critiques." },
    { title: "Offres Imbattables", subtitle: "Les meilleurs prix sur vos jeux préférés." }
  ];

  // --- LOGIQUE DU TOP 3 DYNAMIQUE ---
  const savedVotes = JSON.parse(localStorage.getItem("gamePulseVotes") || "{}");
  const dynamicTop3 = [...gamesList]
    .sort((a, b) => {
      const scoreA = savedVotes[a.id] || a.rating || 0;
      const scoreB = savedVotes[b.id] || b.rating || 0;
      return scoreB - scoreA;
    })
    .slice(0, 3);

  // --- ANIMATIONS ---
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add("visible");
      });
    }, { threshold: 0.1 });
    document.querySelectorAll(".fade-up").forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [gamesList]);

  // --- SLIDER AUTOMATIQUE ---
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  // Filtrage par recherche
  const filteredGames = searchTerm 
    ? gamesList.filter(g => g.title?.toLowerCase().includes(searchTerm.toLowerCase()))
    : gamesList;

  return (
    <main className="home-container">
      {!user && <Login onLogin={setUser} />}

      {/* --- SECTION HERO --- */}
      <section className="hero-premium">
        <video autoPlay loop muted playsInline className="hero-video">
          <source src="/welcome.mp4" type="video/mp4" />
        </video>
        <div className="hero-overlay-blur"></div>
        <div className="hero-content-main">
          <img src="/logox.png" alt="Logo" className="logo-pulse-mini" />
          <h1 className="hero-title">
            {slides[currentSlide].title} <span className="text-highlight">HQ</span>
          </h1>
          <p className="hero-subtitle">{slides[currentSlide].subtitle}</p>
          <div className="hero-btns">
            <button 
              className="btn-primary" 
              onClick={() => gamesSectionRef.current.scrollIntoView({ behavior: 'smooth' })}
            >
              Dernières Sorties
            </button>
            <Link to="/reviews" className="btn-secondary">Voir les Tests</Link>
          </div>
        </div>
      </section>

      <div className="container-fluid">
        <AdComponent adSlot="1234567890" />
        {/* --- ARTICLES À LA UNE (Statique pour l'instant) --- */}
        <section className="home-section fade-up">
          <h2 className="section-title">🔥 À LA UNE EN 2026</h2>
          <div className="horizontal-grid">
            <Link to="/article/gta-6-date-sortie" className="promo-card gta">
              <div className="promo-info"><h3>GTA 6</h3><p>Sortie Officielle</p></div>
            </Link>
            <Link to="/article/top-10-jeux-ps5-2026" className="promo-card ps5">
              <div className="promo-info"><h3>TOP 10 PS5</h3><p>Les indispensables</p></div>
            </Link>
            <Link to="/article/comparatif-ps5-vs-xbox-series-x-2026" className="promo-card vs">
              <div className="promo-info"><h3>PS5 VS XBOX</h3><p>Le verdict</p></div>
            </Link>
          </div>
        </section>

        {/* --- DERNIERS TESTS --- */}
        <section className="home-section fade-up">
          <h2 className="section-title">🧪 DERNIERS TESTS</h2>
          <div className="standard-grid">
            {reviews.slice(0, 3).map(review => (
              <ReviewCard key={review.id} review={review} />
            ))}
          </div>
        </section>

        {/* --- TOP 3 GLOBAL DYNAMIQUE --- */}
        <section className="home-section fade-up">
          <h2 className="section-title">🏆 TOP 3 GLOBAL</h2>
          <div className="standard-grid">
            {dynamicTop3.map((game, index) => (
              <GameCard key={game.id} game={game} rank={index + 1} />
            ))}
          </div>
        </section>

        {/* --- OFFRES SPÉCIALES --- */}
        <section className="home-section fade-up">
          <h2 className="section-title">💸 OFFRES SPÉCIALES</h2>
          <div className="standard-grid">
            {deals.slice(0, 4).map(deal => (
              <DealCard key={deal.id} deal={deal} />
            ))}
          </div>
        </section>

        {/* --- CATALOGUE COMPLET (Sync Firebase) --- */}
        <section className="home-section fade-up" ref={gamesSectionRef}>
          <div className="section-header">
            <h2 className="section-title">🎮 CATALOGUE DE JEUX</h2>
            {searchTerm && <p className="search-result">Résultat pour : "{searchTerm}"</p>}
          </div>

          {loading ? (
            <div style={{ textAlign: "center", padding: "50px", color: "#ec008c" }}>
              Initialisation des systèmes...
            </div>
          ) : (
            <div className="standard-grid">
              {filteredGames.length > 0 ? (
                filteredGames.map(game => (
                  <GameCard key={game.id} game={game} />
                ))
              ) : (
                <p className="no-result">Aucun jeu trouvé.</p>
              )}
            </div>
          )}
        </section>
      </div>
      <AdComponent adSlot="0987654321" />
    </main>
  );
}

export default Home;